import React from "react";
import { Link } from "@/components/common/Link";
import { Linkedin, Youtube, Instagram, Facebook, MessageCircle as WhatsApp } from "lucide-react";
export default function Footer() {
  const socialLinks = [{
    icon: Linkedin,
    href: "https://www.linkedin.com/company/nexel-techonologies",
    label: "LinkedIn"
  }, {
    icon: Youtube,
    href: "https://www.youtube.com/@Nexel.tekone",
    label: "YouTube"
  }, {
    icon: Instagram,
    href: "https://www.instagram.com/nexel.tek/",
    label: "Instagram"
  }, {
    icon: Facebook,
    href: "https://www.facebook.com/profile.php?id=61575416038036",
    label: "Facebook"
  }, {
    icon: WhatsApp,
    href: "https://wa.me/+8615817452996",
    label: "WhatsApp"
  }];
  const columns = [{
    title: "Technical",
    links: [{
      label: "Optical Fibers",
      to: "/ProductsPage"
    }, {
      label: "Drone Systems",
      to: "/ProductsPage"
    }, {
      label: "PDF Datasheets",
      to: "/SupportPage"
    }]
  }, {
    title: "Corporate",
    links: [{
      label: "Our Solutions",
      to: "/SolutionsPage"
    }, {
      label: "Support Hub",
      to: "/SupportPage"
    }, {
      label: "Contact Us",
      to: "/ContactPage"
    }]
  }, {
    title: "Legal",
    links: [{
      label: "Privacy Policy",
      to: "/PrivacyPolicyPage"
    }, {
      label: "Terms of Service",
      to: "/TermsOfServicePage"
    }]
  }];
  return <section data-section-id="46878" id="footer" className="dark bg-[#020617] text-foreground border-t border-cyan-500/30 py-12 font-sans shadow-[0_-10px_40px_rgba(0,255,255,0.05)]">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 lg:gap-12">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604101/img/nexel_tech_corporate_logo.png" alt="Nexel Technologies New Logo" className="h-7 w-auto object-contain drop-shadow-[0_0_8px_rgba(0,255,255,0.6)]" />
            </Link>
            <div className="flex items-center gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} to={social.href} newTab className="text-muted-foreground hover:text-primary transition-colors duration-200" aria-label={social.label} data-index={i}>
                    <Icon className="size-6" />
                  </Link>;
            })}
            </div>
          </div>

          {}
          {columns.map((col, i) => <div key={i} data-index={i} className="flex flex-col gap-4">
              <h3 className="text-sm font-semibold tracking-wider text-primary uppercase">
                {col.title}
              </h3>
              <ul className="flex flex-col gap-2">
                {col.links.map((link, j) => <li key={j} data-index={j}>
                    <Link to={link.to} className="text-xs text-muted-foreground hover:text-foreground transition-colors duration-200 font-mono">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>)}
        </div>

        {}
        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-500 font-mono tracking-wider">
          <p>© 2025&nbsp;Nexel Technologies Co., Ltd. Connecting Intelligence. Empowering Future.</p>
        </div>
      </div>
    </section>;
}